import React from 'react';
import ResultsWinsGoldIcon from '../Icons/ResultsWinsGoldIcon';
import ResultsWinsSilverIcon from '../Icons/ResultsWinsSilverIcon';
import ResultsWinsBronzeIcon from '../Icons/ResultsWinsBronzeIcon';
import clsx from 'clsx';

export default function RankedItem({
  imageURL,
  name,
  wins,
  score,
  itemNum,
  showScore = true,
  description,
}: {
  imageURL: string;
  name: string;
  wins: number;
  score: number;
  itemNum?: number;
  showScore?: boolean;
  description?: string;
}) {
  return (
    <div className={'flex'}>
      <div
        className={clsx(
          'flex items-center gap-2',
          showScore ? 'basis-1/2 p-2' : 'basis-full'
        )}
      >
        {itemNum && <span className={'w-6 block text-center'}>{itemNum}</span>}
        <div className={'relative flex-shrink-0'}>
          {itemNum && itemNum <= 3 && (
            <span
              className={
                'absolute -right-1.5 -top-1.5 h-5 w-5 rounded-full shadow-xs bg-white flex items-center justify-center'
              }
            >
              {itemNum === 1 && <ResultsWinsGoldIcon />}
              {itemNum === 2 && <ResultsWinsSilverIcon />}
              {itemNum === 3 && <ResultsWinsBronzeIcon />}
            </span>
          )}
          {imageURL && (
            <img
              src={imageURL}
              width={'48'}
              height={'36'}
              className={clsx(
                'object-cover rounded-2 aspect-[4/3]',
                showScore ? 'w-12 h-9' : 'w-24 h-18'
              )}
            />
          )}
        </div>
        <div className={'flex flex-col gap-3'}>
          <p>{name}</p>
          {description ? <p>{description}</p> : null}
        </div>
      </div>
      {showScore && (
        <>
          <div className={'flex items-center p-2 basis-1/4'}>{wins}</div>
          <div className={'flex items-center p-2 basis-1/4'}>{score}</div>
        </>
      )}
    </div>
  );
}
